import {useCurrentState} from "../globalState";
import {useAPI} from "../stateHelpers";
import ListItemText from "@material-ui/core/ListItemText";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import React, {useRef, useState} from "react";
import {withRouter} from "react-router-dom";
import {IconButton, ListItemSecondaryAction, Typography} from "@material-ui/core";
import {ValidatorForm} from "react-form-validator-core";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import Button from "@material-ui/core/Button";
import Delete from "@material-ui/icons/Delete";
import {apiDelete, apiPost, apiPut, apiURL} from "../api";
import snackbar from "../snackbar";
import spawnConfirmation from "../confirmationDialog";
import {GenerateInputs} from "./GenericInputField";
import FailedLoading from "./FailedLoading";
import CircularLoader from "./CircularLoader";
import Avatar from "@material-ui/core/Avatar";
import {BigAvatar} from "./Avatars";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";

const themes = ["red", "pink", "purple", "deepPurple", "indigo", "blue", "lightBlue", "cyan", "teal", "green", "lightGreen", "lime", "yellow", "amber", "orange", "deepOrange", "brown", "grey", "blueGrey"].map((t) => {
    return {key: t, label: t};
});

const themesShades = [
    50,
    100,
    200,
    300,
    400,
    500,
    600,
    700,
    800,
    900,
    "A100",
    "A200",
    "A400",
    "A700",
].map((t) => {
    return {key: t.toString(), label: t.toString()}
});

function Identities(props) {

    let [title, setTitle] = useCurrentState("title");
    const {data = [], error, isLoading, setData, doRetry} = useAPI("identity");
    const inputRef = useRef(null);

    let inputs = GenerateInputs({
        id: {
            type: 'hidden'
        },
        name: {
            label: 'Name',
            validators: ['required'],
            errorMessages: ['this field is required']
        },
        email: {
            label: 'E-mail',
            type: 'email',
            help: 'you will have to confirm this e-mail account.',
            validators: ['required', 'isEmail'],
            errorMessages: ['this field is required', 'email is not valid']
        },
        phone: {
            label: 'Phone'
        },
        theme: {
            required: true,
            label: 'Theme',
            type: 'color',
            defaultValue: '#f4511e',
            validators: ['required'],
            errorMessages: ['this field is required']
        },
        theme_secondary: {
            required: true,
            label: 'Secondary Theme',
            type: 'color',
            defaultValue: '#546e7a',
            validators: ['required'],
            errorMessages: ['this field is required']
        },
        logo: {
            label: 'Logo',
            defaultValue: null,
            multi: false,
            type: 'file',
            help: 'Upload a file of at least 1024x1024 pixels in size'
        }
    });


    setTitle("Identities");

    const {
        history,
        ...rest
    } = props;

    if (error) {
        return <FailedLoading retry={doRetry}/>
    }

    if (isLoading) {
        return <CircularLoader/>
    }

    let loading = inputs.name.disabled;

    let deleteIdentity = async (item) => {
        spawnConfirmation().then(() => apiDelete("identity/" + item.id).then(() => {
            setData(data.filter((itm) => itm.id !== item.id));
            snackbar("Deleted.");
        }, () => {
            snackbar("Failed deleting. Please try again!");
        }));
    };

    let submit = () => {
        inputs.disableAll(true);
        let save;
        if (inputs.id.value) {
            save = apiPut("identity/" + inputs.id.value, inputs.toFormData());
        } else {
            save = apiPost("identity", inputs.toFormData());
        }
        save.then(res => {
            snackbar("Saved.");
            doRetry();
        }, res => {
            snackbar("Error: " + res.response.data.message);
        }).finally(() => inputs.disableAll(false));
    };

    let setEdit = (item) => {
        for (let key of Object.keys(inputs)) {
            let field = inputs[key];
            if (field.setValue) {
                field.setValue(item[key]);
            }
        }
    };

    let reset = () => {
        for (let key of Object.keys(inputs)) {
            let field = inputs[key];
            if (field.setValue) {
                field.setValue("");
            }
        }
    };

    return (
        <div>
            <div style={{padding: 16}}>
                <div>
                    <Card>
                        <CardContent>
                            <div>
                                <Typography variant="h5" component="h2">Add new identity</Typography>
                                <div>
                                    <ValidatorForm ref={inputRef} onSubmit={submit} noValidate autoComplete="off">
                                        <div>
                                            {inputs.id.field}
                                            {inputs.name.field}
                                        </div>
                                        <div>
                                            {inputs.email.field}
                                        </div>
                                        <div>
                                            {inputs.phone.field}
                                        </div>

                                        <div>
                                            {inputs.theme.field}
                                        </div>


                                        <div>
                                            {inputs.theme_secondary.field}
                                        </div>



                                        <div>
                                            {inputs.logo.field}
                                        </div>
                                    </ValidatorForm>
                                </div>
                            </div>
                        </CardContent>
                        <CardActions>
                            <Button onClick={() => submit()} disabled={loading} color="primary">
                                Save
                            </Button>
                            <Button onClick={() => reset()} disabled={loading} color="primary">
                                Cancel
                            </Button>
                        </CardActions>
                    </Card>
                </div>
            </div>
            <List>
                {(data || []).map((item) => <ListItem button
                                                      onClick={() => setEdit(item)}
                                                      key={item.id} alignItems="flex-start">

                    <ListItemAvatar>
                        {item.logo ? <BigAvatar src={apiURL('serve/' + item.logo + "?width=100")}/> :
                            <BigAvatar>{item.name[0]}</BigAvatar>}
                    </ListItemAvatar>
                    <ListItemText
                        primary={item.name}
                        secondary={item.email}
                    />
                    <ListItemSecondaryAction>
                        <IconButton onClick={() => deleteIdentity(item)}>
                            <Delete/>
                        </IconButton>
                    </ListItemSecondaryAction>
                </ListItem>)}
            </List>
        </div>
    )
}

export default withRouter(Identities);